import { defineAsyncComponent } from 'vue'
import './font.css'
import './tokens.css'
import './overrides.css'
import './legacy-primitives.css'
import { assets } from './assets'
import { icons } from './icons'

export const components = Object.freeze({
  'landing-page': defineAsyncComponent(() => import('./components/MarsTradeLandingPage.vue')),
  'home-dashboard': defineAsyncComponent(() => import('./components/MarsTradeHomeDashboard.vue')),
  'user-sidebar-transfer-actions': defineAsyncComponent(() =>
    import('./components/MarsTradeUserSidebarTransferActions.vue')
  )
})

export const copy = Object.freeze({
  profileNavigationTitle: 'marsTradeLanding.accountCenterTitle',
  profileNavigationLink: 'marsTradeLanding.accountCenterLink'
})

export const options = Object.freeze({
  profilePageSummary: false,
  adaptiveAdminCarousel: true,
  adminSidebarSubnavigation: true
})

export { assets }
export { icons }
